<template>
  <basic-scrolling-with-gradient :has-gradient="hasGradient">
    <div :class="{ 'the-grid': ['maxi'].includes(size) }">
      <div
        v-if="stepTitle || $slots.title"
        class="dvp-modal__title"
      >
        <template v-if="stepTitle">
          <span
            :id="titleId"
            :class="{ h3: size !== 'mini', 'title-1': size === 'mini' }"
            v-html="stepTitle"
          />
        </template>
        <template v-else>
          <div
            :id="titleId"
            :class="{ h3: size !== 'mini', 'title-1': size === 'mini' }"
          >
            <slot name="title" />
          </div>
        </template>
      </div>
      <div class="dvp-modal__body body-2">
        <slot />
      </div>
    </div>
  </basic-scrolling-with-gradient>
</template>

<script setup>
  import { computed, inject } from 'vue'

  import BasicScrollingWithGradient from '@shared/components/Basic/ScrollingWithGradient'

  // INIT
  const size = inject('size')
  const hasGradient = inject('hasGradient')
  const stepTitle = inject('stepTitle')
  const stepId = inject('stepId')

  // COMPUTED
  const titleId = computed(() => {
    return `${stepId}-title`
  })
</script>

<style scoped>
.dvp-modal__title {
  margin: 0 0 var(--dotcom-responsive-spacing-res-xxs) 0;
}

.dvp-modal--mini .dvp-modal__title {
  margin: 0 0 var(--fixed-spacing-fix-02) 0;
}

.dvp-modal--maxi .dvp-modal__title,
.dvp-modal--maxi .dvp-modal__body {
  grid-column: 1 / -1;
}

.dvp-modal__body {
  margin: 0 0 var(--dotcom-responsive-spacing-res-xxs) 0;
}
</style>
